import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Main } from "@layouts/Main";
import { CodeVerification } from "@pages/home/CodeVerification";
import { IdentityVerificationByBirth } from "@pages/home/IdentityVerificationByBirth";
import { IdentityVerificationBySms } from "@pages/home/IdentityVerificationBySms";
import { TestIdentification } from "@pages/home/TestIdentification";
import { useEcoaBreadcrumb } from "@hooks/useEcoaBreadcrumb";
import { PreScreeningBySiteRedirect, PreScreeningRoute } from "./PreScreeningRoute";

interface HomeRouteProps {}

export function HomeRoute(props: HomeRouteProps) {
  const match = useRouteMatch();
  const { header, footer } = useEcoaBreadcrumb();

  return (
    <Switch>
      <Route path={`${match.url}:studyId(\\d+)/sites/:siteId(\\d+)`} render={() => <PreScreeningBySiteRedirect />} />
      <Route path={`${match.url}:studyId(\\d+)`} render={() => <PreScreeningRoute />} />
      <Main header={header} footer={footer}>
        <Switch>
          {process.env.REACT_APP_STAGE === "local" && <Route exact path={`/test-identification`} component={TestIdentification} />}
          <Route exact path={`${match.url}`} component={CodeVerification} />
          <Route path={`${match.url}auth/birth`} component={IdentityVerificationByBirth} />
          <Route path={`${match.url}auth/sms`} component={IdentityVerificationBySms} />
          <Redirect from="*" to="/404?hr" />
        </Switch>
      </Main>
    </Switch>
  );
}
